import {
  userBackupDetailPath,
  organizationInformationPath,
  resellersListPath,
} from '@config/Routes/WebClientRoutes';

export const GOOGLE_GROUP = 'google_group';
export const GOOGLE_GROUP_TEXT = 'Google Group';
export const GOOGLE_GROUP_COLUMNS = [
  { label: 'ID', columnName: 'userBackupId' },
  {
    label: 'Group Name',
    columnName: 'groupName',
    size: 'sm',
    navigateURL: (row) => {
      const email = encodeURIComponent(`${row.groupName} - ${row.domainName}`);
      return `${userBackupDetailPath}?id=${row.userBackupId}&email=${email}&backupType=${GOOGLE_GROUP}`;
    },
  },
  {
    label: 'Domain Name',
    columnName: 'domainName',
    size: 'sm',
  },
  {
    label: 'Organization Name',
    columnName: 'organizationName',
    size: 'sm',
    navigateURL: (row) =>
      `${organizationInformationPath}?id=${row.organizationId}&name=${row.organizationName}`,
  },
  {
    label: 'Partner Name',
    columnName: 'partnerName',
    size: 'sm',
    navigateURL: (row) => `${resellersListPath}?id=${row.partnerId}&name=${row.partnerName}`,
  },
  {
    label: 'Parent Name',
    columnName: 'distributorName',
    size: 'sm',
    navigateURL: (row) =>
      `${resellersListPath}?id=${row.distributorId}&name=${row.distributorName}`,
  },
  { label: 'Email', columnName: 'email', size: 'sm' },
  { label: 'Active', columnName: 'active', size: 'sm' },
  { label: 'Mailbox Hidden', columnName: 'mailboxHidden', size: 'sm' },
  { label: 'Last Backup At', columnName: 'lastBackupAt', size: 'sm' },
  { label: 'Last Backup Status', columnName: 'lastBackupStatus', size: 'sm' },
  {
    label: 'Last Backup Successful At',
    columnName: 'lastBackupSuccessfulAt',
    size: 'sm',
  },
  { label: 'Next Backup At', columnName: 'nextBackupAt', size: 'sm' },
  { label: 'Created At', columnName: 'createdAt', size: 'sm' },
  { label: 'Last Data Updated At', columnName: 'updatedAt', size: 'sm' },
  { label: 'Deactivated Since', columnName: 'deactivatedSince', size: 'sm' },
  { label: 'Deactivated By', columnName: 'deactivatedBy', size: 'sm' },
];
export const GOOGLE_GROUP_DETAIL_ROWS = {
  userBackupId: 'Group Account ID',
  groupName: 'Group Name',
  domainName: 'Domain Name',
  organizationName: 'Organization Name',
  partnerName: 'Partner Name',
  distributorName: 'Parent Name',
  email: 'Email',
  active: 'Active',
  itemId: 'Item ID',
  messageCount: 'Total Messages',
  membersCount: 'Total Members',
  storageUsed: 'Storage Used',
  disableConversationHistory: 'Disable Conversation History',
  collaborative: 'Collaborative',
  lastBackupId: 'Last Backup ID',
  lastBackupAt: 'Last Backup At',
  lastBackupSuccessfulAt: 'Last Successful Backup At',
  nextBackupAt: 'Next Backup At',
  deactivatedSince: 'Deactivated Since',
  deactivatedBy: 'Deactivated By',
  modifiedAt: 'Modified At',
  modifiedBy: 'Modified By',
  deltaTime: 'Delta Time',
  createdAt: 'Created At',
  updatedAt: 'Last Data Updated At',
};
export const GOOGLE_GROUP_LAST_BACKUP_ROWS = {
  backupId: 'Last Group Backup ID',
  userBackupId: 'Group Account ID',
  startTime: 'Start Backup Time',
  endTime: 'End Backup Time',
  status: 'Backup Status',
  backupStorage: 'Backup Storage (in Byte)',
  currentFilesCount: 'Current File Numbers',
  totalFilesCount: 'Total File Numbers',
  retries: 'Retries Time',
  errorMessage: 'Error Message',
  machineIP: 'Run on Machine IP',
  backupState: 'Backup State',
  matterCleanedUp: 'Matter Cleaned Up',
  matterId: 'Matter ID',
  exportId: 'Export ID',
  createdAt: 'Created At',
  updatedAt: 'Last Updated At',
};
